export default __webpack_public_path__ + "static/media/logo_Direccion-de-Vigilancia.0781a601.png";